import React, { Fragment, useEffect, useState } from "react";
import moment from 'moment';

import { api } from "../../_services/api.service";
import { Row, Col, Card, CardBody } from "reactstrap";
import PageTitle from "../../Layout/AppMain/PageTitle";
import GeneralGrid from "../../Components/GeneralGrid";
import Loader from "react-loaders";
import { CustomInput } from "reactstrap";

const FullUserList = (props) => {
  // let partnerId = parseInt(props.match.params.partnerId);

  let [selectedPartnerId, setSelectedPartnerId] = useState(0);
  let [userList, setUserList] = useState([]);
  let [partnerList, setPartnerList] = useState([]);
  let [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadData(selectedPartnerId);
  }, []);

  const loadData = (pid) => {
    setIsLoading(true);

    api.getAllPartners().then((pts) => {
      setPartnerList(pts);
    });

    api.getUsers(pid).then((data) => {
      setUserList(data);
      setIsLoading(false);
    });
  };

  const goToDetails = (userId) => {
    props.history.push({
      pathname: `/fullprofile/${userId}`,
    });
  };

  const onPartnerSelectionChanged = (val) => {
    setSelectedPartnerId(val);
    loadData(val);
  };

  const columns = [
    {
      dataField: "firstName",
      text: "Name",
      headerStyle: () => {
        return { width: "15%" };
      },
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <a
            key={row.userID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToDetails(row.userID);
            }}
          >
            {row.firstName + " " + row.lastName}
          </a>
        );
      },
    },
    {
      dataField: "email",
      text: "Email",
      headerStyle: () => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      dataField: "scenarioCount",
      text: "# Decisions",
      headerStyle: () => {
        return { width: "10%" };
      },
      sort: true,
    },
    {
      dataField: "userSubscriptionStartDT",
      text: "Start Date",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return cellContent ? moment(cellContent).format("L") : "";
      },
    },
    {
      dataField: "combinedSubscriptionInfo",
      text: "Subscription(s)",
      headerStyle: () => {
        return { width: "30%" };
      },
      formatter: (cellContent, row) => {
        return <div dangerouslySetInnerHTML={{ __html: cellContent }} />;
      },
      sort: true,
    },
    {
      dataField: "inactive",
      headerStyle: () => {
        return { width: "10%" };
      },
      text: "Inactive",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <CustomInput
            readOnly={true}
            type="checkbox"
            id={row.partnerID}
            checked={row.inactive}
          />
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "lastName",
      order: "asc",
    },
  ];

  const options = {
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
    ],
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  return (
    <Fragment>
      <PageTitle icon="fas fa-users" heading={"Users"} />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginBottom: "40px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                {partnerList.length > 0 && (
                  <CustomInput
                    type="select"
                    id="partId"
                    value={selectedPartnerId}
                    name="selpartId"
                    onChange={(e) => onPartnerSelectionChanged(e.target.value)}
                  >
                    <option key={0} value={0}>
                      All Partners
                    </option>
                    {partnerList.map((gc) => {
                      return (
                        <option key={gc.partnerID} value={gc.partnerID}>
                          {gc.partnerName}
                        </option>
                      );
                    })}
                  </CustomInput>
                )}
                {userList.length > 0 && (
                  <GeneralGrid
                    title=""
                    keyField="userID"
                    defaultSortedColumn="firstName"
                    dataSource={userList}
                    filterColumns={["firstName", "lastName"]}
                    columns={columns}
                    defaultSorted={defaultSorted}
                    options={options}
                  />
                )}
                {userList.length == 0 && <p>No users to display</p>}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default FullUserList;
